import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FINAL_RESULTS_COLUMNS, FINAL_RESULTS_ROWS, FINAL_RESULTS_SECTION_TITLE } from "../data";
import { useStyles } from "./styles";

const FinalResultsPanel = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const [step, setStep] = useState("50");

  return (
    <Box className={styles.panelSection}>
      <Typography className={styles.panelSectionTitle}>
        {t(FINAL_RESULTS_SECTION_TITLE)}
      </Typography>

      <Box className={styles.finalResultsTable}>
        <Box className={styles.finalResultsHeaderRow}>
          <Typography className={styles.finalResultsHeaderCell}>
            {t(FINAL_RESULTS_COLUMNS.parameter)}
          </Typography>
          <Typography className={styles.finalResultsHeaderCell}>
            {t(FINAL_RESULTS_COLUMNS.current)}
          </Typography>
          <Typography className={styles.finalResultsHeaderCell}>
            {t(FINAL_RESULTS_COLUMNS.allowed)}
          </Typography>
          <Typography className={styles.finalResultsHeaderCell}>
            {t(FINAL_RESULTS_COLUMNS.margin)}
          </Typography>
          <Typography className={styles.finalResultsHeaderCell}>
            {t(FINAL_RESULTS_COLUMNS.percent)}
          </Typography>
          <Typography className={styles.finalResultsHeaderCell}>
            {t(FINAL_RESULTS_COLUMNS.status)}
          </Typography>
        </Box>

        {FINAL_RESULTS_ROWS.map((row, index) => (
          <React.Fragment key={row.parameterKey}>
            {index > 0 && <Box className={styles.divider} />}
            <Box className={styles.finalResultsBodyRow}>
              <Typography className={styles.finalResultsValueCell}>
                {t(row.parameterKey)}
              </Typography>
              <Typography className={styles.finalResultsValueCell}>{row.currentValue}</Typography>
              <Typography className={styles.finalResultsValueCell}>{row.allowedValue}</Typography>
              <Typography className={styles.finalResultsValueCell}>{row.marginValue}</Typography>
              <Typography className={styles.finalResultsValueCell}>{row.allowedPercent}</Typography>
              <Typography className={styles.finalResultsValueCell}>{t(row.statusKey)}</Typography>
            </Box>
          </React.Fragment>
        ))}
      </Box>

      <Box className={styles.finalResultsActionsBox}>
        <Typography className={styles.finalResultsHint}>
          {t("WORK_ORDER.CENTRE_OF_GRAVITY.FINAL_RESULTS.ACTIONS.HIST_HINT")}
        </Typography>
        <Box className={styles.finalResultsControls}>
          <Box className={styles.chassisInputFieldCell}>
            <Typography className={styles.chassisFieldLabel}>
              {t("WORK_ORDER.CENTRE_OF_GRAVITY.FINAL_RESULTS.ACTIONS.STEP")}
            </Typography>
            <TextField
              className={styles.chassisValueInput}
              variant="outlined"
              value={step}
              onChange={(event) => setStep(event.target.value)}
            />
          </Box>
          <Button className={styles.finalResultsSuccessBtn} variant="outlined">
            {t("WORK_ORDER.CENTRE_OF_GRAVITY.FINAL_RESULTS.ACTIONS.INCREASE_MARGIN")}
          </Button>
          <Button className={styles.finalResultsDangerBtn} variant="outlined">
            {t("WORK_ORDER.CENTRE_OF_GRAVITY.FINAL_RESULTS.ACTIONS.DECREASE_MARGIN")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default FinalResultsPanel;
